import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DIC } from '../dic';
import { GN } from '../../gn';
import { VehicleService } from '../../vehicles';

declare var google;
declare var RichMarker;
declare var RichMarkerPosition;

/**
 * Generated class for the ShowpoiroutePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-showpoiroute',
  templateUrl: 'showpoiroute.html',
})
export class ShowpoiroutePage {
  @ViewChild('mapFullPoiRoute') mapElement: ElementRef;
  obj: any
  MapPoiRoute: any
  googleX: any
  googleY: any
  vehiclesOnMap = ["0"]
  allVehiclesVisible = 1;

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public vs: VehicleService) {
    this.obj = navParams.get('obj')
  }

  ionViewDidLoad() {
    this.initMapGM()
  }

  initMapGM() {
    var mapOptions = {
      zoom: 15,
      maxZoom: 20,
      minZoom: 6,
      fullscreenControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP,
      },
      mapTypeId: 'roadmap'
    }
    this.MapPoiRoute = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.gn._Post('/api/gn/insertgoogleuse', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), path: this.gn.crypt('map view') }, function () {
    })

    this.MapPoiRoute.setCenter({ lat: 41.998802, lng: 21.427379 })
    // console.log(this.gn.Vehicles)
    this.loadVehiclesOnMap()
    var _that = this
    document.getElementById('mapFull').addEventListener("mousemove", function (e) {
      _that.googleX = e.screenX - 20
      _that.googleY = e.screenY
    });
    google.maps.event.trigger(this.MapPoiRoute, "resize");

    google.maps.event.addListener(this.MapPoiRoute, 'maptypeid_changed', function () {
      _that.gn.setCookie("cmaptypeid", _that.MapPoiRoute.getMapTypeId(), 7);
      _that.gn.setCookie("cmaptypeiduid", _that.gn.user.UserId, 7);
    });
  }

  formatSec(_sec) {
    // console.log(_sec)
    var date = new Date(null); date.setSeconds(_sec);
    var result = date.toISOString().substr(11, 8);
    return result
  }

  RoundFloat(_txt) {
    return parseFloat(parseFloat(_txt + '').toFixed(1));
  }

  showInfo() {
    document.getElementById('routeInfo').classList.remove('routeInfoHide')
  }

  loadVehiclesOnMap() {
    //za sofer
    if (this.gn.user.driverid != -1) {
      var _that = this
      this.gn.Vehicles = []
      this.gn.VehiclesSortDt = []
      this.gn.VehiclesDic = []
      this.vehiclesOnMap = []
      this.allVehiclesVisible = 0;
      this.vs.loadInitVehicles(function () {
        for (var i = 0; i < _that.gn.Vehicles.length; i++) {
          var tf = false;
          if (_that.gn.Vehicles[i].driver + '' == _that.gn.user.UserFullName + '') {
            //KRISTINA NEW !
            var _pts = []
            _pts.push({ lon: parseFloat(_that.obj.ll.split(', ')[1]), lat: parseFloat(_that.obj.ll.split(', ')[0]) })

            var img = 'assets/imgs/newpin-red.png'
            var markerIcon = {
              url: img,
              scaledSize: new google.maps.Size(38, 43),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(13, 43),
              labelOrigin: new google.maps.Point(13, 13)
            };

            /*done*/ var endmarker = new google.maps.Marker({
              position: { lat: parseFloat(_that.obj.ll.split(', ')[0]), lng: parseFloat(_that.obj.ll.split(', ')[1]) },
              map: _that.MapPoiRoute,
              icon: markerIcon,
              label: {
                text: 'END',
                color: "#000",
                fontSize: "8px",
                fontWeight: "bold"
              }
            });

            var _lon = parseFloat(_that.gn.Vehicles[i].lon)
            var _lat = parseFloat(_that.gn.Vehicles[i].lat)

            _pts.push({ lon: _lon, lat: _lat })

            _that.gn.Socket.emit({ routeby: _that.gn.clientsettings.routeby, cid: _that.gn.user.ClientId, uid: _that.gn.user.UserId, points: _pts, TollRoad: 'no', Highways: 'no', Ferry: 'no', Type: 'shortest', Unit: "k" }, function (_data) {
              var _pp = []
              var bounds = new google.maps.LatLngBounds();

              for (var i = 0; i < _data.routes.length; i++) {
                var _route = _data.routes[i]
                for (var j = 0; j < _route.points.length; j++) {
                  _pp.push({ lat: parseFloat(_route.points[j].lat), lng: parseFloat(_route.points[j].lng) })
                  bounds.extend({ lat: parseFloat(_route.points[j].lat), lng: parseFloat(_route.points[j].lng) });
                }
              }
              _that.MapPoiRoute.fitBounds(bounds);
              _that.drawLine(_pp)

              console.log(' @@@@ ' + parseInt(_data.distance));

              //document.getElementById('routeInfo').innerHTML = parseInt(_data.distance) + '' + parseInt(_data.time)


              var _url = "https://www.google.com/maps/dir/" + _pts[1].lat + "," + _pts[1].lon + "/" + _pts[0].lat + "," + _pts[0].lon + "/data=!3m1!4b1!4m2!4m1!3e0"


              var _htmlInfo = `<div>
                <ion-icon class="licon ion-ios-pin-outline"></ion-icon>
                <span class="mvld-label1">`+ _that.dic.l["locateVisit"] + `: </span>
                <span class="mvld-label2">`+ _that.obj.loc + `</span>
              </div>`
              _htmlInfo += `<div>
                <ion-icon class="licon ion-ios-timer-outline"></ion-icon>
                <span class="mvld-label1">`+ _that.dic.l["Time"] + `: </span>
                <span class="mvld-label2">`+ _that.formatSec(parseInt(_data.time)) + `</span>
              </div>`
              _htmlInfo += `<div>
                <ion-icon class="licon ion-ios-resize-outline"></ion-icon>
                <span class="mvld-label1">`+ _that.dic.l["Distance"] + `: </span>
                <span class="mvld-label2">`+ _that.RoundFloat(_data.distance * _that.gn.user.metricvalue) + ` ` + _that.gn.user.metric + `</span>
              </div>`
              _htmlInfo += `<a target="_blank" href="` + _url + `">
                <button class="btn-nav">`+ _that.dic.l["navigate"] + `</button>
              </a>`
              document.getElementById('routeInfo').innerHTML = _htmlInfo

            }, 'getDirections')

            //KRISTINA NEW END !


            tf = true;
            _that.vehiclesOnMap.push(_that.gn.Vehicles[i].vehicleid)
          }
          //ako nema niedno dozvoleno vozilo soferot da ja centrira mapata fiksno negde
          if (!tf) {
            _that.gn.Vehicles[i].tmpVisible = false;
          }
        }
        _that.doLoadVeh()
      })
    } else {
      this.doLoadVeh();
    }
  }

  drawLine(_points) {
    var _Line = new google.maps.Polyline({
      path: _points,
      strokeColor: '#5075b1',
      strokeOpacity: 1,
      strokeWeight: 4
    });
    _Line.setMap(this.MapPoiRoute)
    //this.PathLines.push(_Line)
  }


  CenterMap() {
    var bounds = new google.maps.LatLngBounds();
    for (var i = 0; i < this.gn.Markers.length; i++) {
      bounds.extend(this.gn.Markers[i].position);
    }
    this.MapPoiRoute.fitBounds(bounds);

    var _that = this
    setTimeout(function () {
      //ako e sofer i nema dodeleno nitu edno vozilo da mu ja centrira fiksno mapata
      if (_that.gn.user.driverid != -1 && _that.gn.Markers.length == 0) {
        _that.setCenter(21.427379, 41.998802);
      }
    }, 200)
  }
  setCenter(_lon, _lat) {
    this.MapPoiRoute.panTo(new google.maps.LatLng(_lat, _lon));
  }
  getCenter() {
    var _lat
    var _lon
    _lon = this.MapPoiRoute.getCenter().lng()
    _lat = this.MapPoiRoute.getCenter().lat()
    return { lon: _lon, lat: _lat }
  }
  setZoom(_zoom) {
    this.MapPoiRoute.setZoom(_zoom)
  }
  getZoom() {
    return this.MapPoiRoute.getZoom()
  }


  doLoadVeh() {
    var _features = []
    this.gn.Markers = []
    this.gn.VehicleAnim = []
    // console.log(this.gn.Vehicles)
    for (var i = 0; i < this.gn.Vehicles.length; i++) {
      // console.log(this.gn.Vehicles[i].visible, this.gn.Vehicles[i].tmpVisible, this.gn.Vehicles[i])
      if (this.gn.Vehicles[i].visible == 1 && this.gn.Vehicles[i].tmpVisible == true) {
        // console.log('***** SWITCH '+this.gn.Vehicles[i].vehicleid)
        var v = this.gn.Vehicles[i]
        var _lon = parseFloat(v.lon)
        var _lat = parseFloat(v.lat)

        var el = document.createElement("DIV");
        var _objclassname = "gn-ol-market" + this.gn.user.vehsize + " gn-car-" + v.color
        // console.log(v, 'vvv')
        // console.log(v.vehicleid, 'vehicleid daj da vidam')
        // console.log(this.gn.Organisations, 'daj da vidam orgn')

        //pulse class na follow vozila
        var selFollVeh = this.gn.getCookie("selfollvehids");
        if (selFollVeh != '' && (selFollVeh.indexOf(v.vehicleid) != -1)) {
          _objclassname += " pulseV"
        }
        el.className = _objclassname;

        for (let oo = 0; oo < this.gn.Organisations.length; oo++) {
          if (v.organisationid == this.gn.Organisations[oo].id) {
            if (this.gn.Organisations[oo].color != null)
              el.style.border = "5px solid " + this.gn.Organisations[oo].color;
            el.style.boxSizing = "content-box"
            el.style.boxShadow = "0px 0px 10px #000"

          }
        }

        el.innerHTML = '<span style="z-index:1; position: relative; word-wrap:normal">' + v.code + '</span>'

        var _dimg01 = 'none';
        var _dimg02 = 'none';
        var _dimg03 = 'none';

        if ((v.lostcomm + '' == '1' || v.lostcomm15 + '' == '1') && v.status + '' == '1') {
          _dimg01 = 'block';
        }
        if (v.status + '' == '0' && v.lostcomm + '' == '0' && v.lostcomm15 + '' == '0') {
          _dimg02 = 'block';
        }
        if ((v.lostcomm + '' == '1' || v.lostcomm15 + '' == '1') && v.status + '' == '0') {
          _dimg03 = 'block';
        }

        el.innerHTML += '<img id="gncarimg01-' + v.code + '" item-start src="assets/imgs/nocommunication.png" class="live-img-03" style="top: -11px; left: 15px; display:' + _dimg01 + '"/>'
        el.innerHTML += '<img id="gncarimg02-' + v.code + '" item-start src="assets/imgs/nosignal.png" class="live-img-03" style="top: -11px; left: 15px; display:' + _dimg02 + '"/>'
        el.innerHTML += '<img id="gncarimg03-' + v.code + '" item-start src="assets/imgs/sigcomm.png" class="live-img-04" style="top: -10px; left: 10px; display:' + _dimg03 + '"/>'


        el.innerHTML += '<span class="gn-nouse' + this.gn.user.vehsize + '"></span>'
        el.setAttribute('car-code', v.code)
        el.setAttribute('id', 'gncar-' + v.code)
        el.setAttribute('iattr', '' + i)


        var marker = new RichMarker({
          position: new google.maps.LatLng(_lat, _lon),
          map: this.MapPoiRoute,
          draggable: false,
          content: el.outerHTML,
          anchor: RichMarkerPosition.MIDDLE,
          i: i
        });

        //NEW !!!
        var _that = this
        //za soferite na mobilen da ima balonce samo na klik
        if (_that.gn.user.driverid == -1 || (<HTMLElement>document.getElementById('mob-footer')).offsetHeight == 0) {
          // marker.addListener('mouseover', function () {
          //   var v = _that.gn.Vehicles[this.i]
          //   var h = _that.vehBaloon(v)
          //   var _html = `@` + h
          //   _that.showUnderMouse(_html, _that.googleX - 40, _that.googleY - 80)
          // })
          //NEW !!!!!
          // marker.addListener('mouseout', function () {
          //   document.getElementById('map-undermouse-popup').setAttribute('gtimer', '0')
          // })
        } else {
          // marker.addListener('click', function () {
          //   var v = _that.gn.Vehicles[this.i]
          //   var h = _that.vehBaloon(v)
          //   var _html = `@` + h
          //   _that.showUnderMouse(_html, _that.googleX - 40, _that.googleY - 80)
          // })
          document.getElementById('mapFullPoiRoute').addEventListener('click', function (e) {
            var x = e.clientX
            var y = e.clientY
            var els = document.elementsFromPoint(x, y);
            var ee = []

            var cnt = 0;
            for (var i = 0; i < els.length; i++) {
              if (els[i].classList.contains('routeInfo')) {
                cnt++;
              }
              if (i == els.length - 1 && cnt == 0) {
                document.getElementById('routeInfo').classList.add('routeInfoHide')
              }
            }
          })
        }
        // marker.addListener('mouseout', function () {
        //   var el = document.getElementById('map-undermouse-popup')
        //   if (el != null) {
        //     el.setAttribute('gtimer', '0')
        //   }
        // })
        //NEW !!!

        this.gn.Markers.push(marker)
        this.gn.VehicleAnim.push()
        this.gn.VehicleAnim.push({ code: v.code, lon: _lon, lat: _lat, marker: marker, anim: [] })
      }
    }
    this.CenterMap()
  }

}



// WEBPACK FOOTER //
// ./src/pages/showpoiroute/showpoiroute.ts